import { createCommand } from "lexical";

export const INSERT_DATA_TABLE_COMMAND = createCommand();
